import { get } from '@/utils/request';

export const config = () => {
  return get('/api/v1/config/1');
};

export const policymodelconfig = () => {
  return get('/api/v1/config/2');
};
